<template>
  <div class="container-fluid">
     <p>&nbsp;</p>
      <div class="top-menu"> 
        <div class="top-brand">
          <img src="../assets/logo.png" alt="PlePower">
          <div class="top-brand-copy">
            <strong>PlePower</strong>
            <span>Utility Dashboard</span>
          </div>
        </div>
        <div class="menu">
          <button class="menu-link" :class="{ active: is_paybills }" @click="pay_bills">Pay Bills</button>
          <button class="menu-link" :class="{ active: is_transaction_history }" @click="transaction_history">Transaction History</button>
          <button class="menu-link" :class="{ active: is_wallet_history }" @click="wallet_history">Wallet History</button>
          <button class="menu-link" :class="{ active: is_contact_us }" @click="contact_us">Contact Us</button>
        </div>
      </div>
      <div class="border-bottom"></div>
      <div class="marquee">
        <div class="marquee-track">
          <div class="marquee-content">
            <span class="marquee-badge"><i class="fa fa-bullhorn"></i> System Maintenance in Progress</span>
            <span class="marquee-text">We are currently performing routine updates to improve our system. During this time, services may be temporarily unavailable. Thank you for your patience and understanding!</span>
            <span class="marquee-separator"></span>
            <span class="marquee-badge"><i class="fa fa-bolt"></i> Quick Tip</span>
            <span class="marquee-text">Your latest subscription details remain available for easy access anytime.</span>
          </div>
          <div class="marquee-content" aria-hidden="true">
            <span class="marquee-badge"><i class="fa fa-bullhorn"></i> System Maintenance in Progress</span>
            <span class="marquee-text">We are currently performing routine updates to improve our system. During this time, services may be temporarily unavailable. Thank you for your patience and understanding!</span>
            <span class="marquee-separator"></span>
            <span class="marquee-badge"><i class="fa fa-bolt"></i> Quick Tip</span>
            <span class="marquee-text">Your latest subscription details remain available for easy access anytime.</span>
          </div>
        </div>
      </div>
      <div class="search-bar mt-4">
        <div class="inputs-panel">
          <p class="welcome">Hello, {{ firstname }}.</p>
          <!-- <p class="welcome1">What do you want to do today?</p> -->
        </div>
        <div>
         
        </div>
      </div>
      <div class="account-summary">
        <div class="wallet-overview-card">
          <div class="wallet-overview-top">
            <div>
              <p class="summary-eyebrow">PlePower Wallet</p>
              <h3>{{ walletStatus === 'missing' ? 'Create your wallet' : formatCurrency(wallet_balance) }}</h3>
            </div>
            <button v-if="wallet_balance !== 0" class="summary-action" @click="handleWalletAction(account_number)"><i class="fa fa-money"></i> Transfer To Other Wallet</button>
          </div>
          
          <div class="wallet-overview-meta">
            <span>{{ walletStatusMessage }}</span>

          </div>

          <!-- First Time User Modal -->
          <div v-if="showFundModal" class="custom-modal-overlay">
            <div class="custom-modal-box">
              
              <div class="modal-icon">
                <i class="fa fa-wallet"></i>
              </div>

              <h3 style="color: black;">Hello {{ firstname }}</h3>

              <p class="modal-message">
                Kindly fund your account to continue enjoying PlePower services such as:
                Electricity Subscription, Airtime Purchase, Data Purchase and Cable TV Subscription.
              </p>

              <button class="modal-btn" @click="closeFundModal">
                Okay
              </button>

            </div>
            </div>
        </div>
        <div class="account-details-card">
          <p class="summary-eyebrow"> Account Details</p>
          <h4>{{ account_name || 'No account added yet' }}</h4>
          <div class="account-detail-grid">
            <div class="account-detail-item">
              <span class="detail-separator">
              {{ bank_name ? '' + bank_name : '' }}
            </span>
            <span class="detail-label">Account Number</span>
            <strong class="account-number-copy">
              {{ account_number || 'Not available' }}
            </strong>
           
            </div>
            <span class="the-copy-icon"><i
                v-if="account_number"
                class="fa fa-copy copy-icon"
                @click="copyToClipboard(account_number)"
                title="Copy Account Number"
              ></i></span>
            
          </div>
          <small class="text-mutted">{{ copyText }}</small>
          <button
            v-if="!bank_name || !account_number"
            class="create-wallet-inline"
            :disabled="loading"
            @click="create_wallet"
          >
            <span v-if="loading" class="wallet-inline-spinner" aria-hidden="true"></span>
            <span>{{ loading ? 'Creating Wallet...' : 'Create Wallet' }}</span>
          </button>
        </div>
      </div>
       <div class="pay-bills" v-if="is_paybills">
        <div class="pay-bills-header">
          <div>
            <p class="pay-bills-eyebrow">Utility Services</p>
            <h3><strong>Pay Bills</strong></h3>
            <span>Select a service to continue with a secure payment.</span>
          </div>
        </div>
        <div class="bills">
            <div class="bill-box" @click="buy_electricity()">
              <div class="bill-box-top">
                <span class="bill-icon electricity-icon"><i class="fa-solid fa-lightbulb"></i></span>
                <span class="bill-arrow"><i class="fa fa-arrow-right"></i></span>
              </div>
              <div class="bill-copy">
                <h4>Electricity</h4>
                <p>IKEDC, AEDC</p>
              </div>
            </div>
            <div class="bill-box" @click="buy_airtime()">
              <div class="bill-box-top">
                <span class="bill-icon airtime-icon"><i class="fa-solid fa-phone"></i></span>
                <span class="bill-arrow"><i class="fa fa-arrow-right"></i></span>
              </div>
              <div class="bill-copy">
                <h4>Airtime</h4>
                <p>MTN, GLO, AIRTEL</p>
              </div>
            </div>
            <div class="bill-box" @click="buy_data()">
              <div class="bill-box-top">
                <span class="bill-icon data-icon"><i class="fas fa-wifi"></i></span>
                <span class="bill-arrow"><i class="fa fa-arrow-right"></i></span>
              </div>
              <div class="bill-copy">
                <h4>Data</h4>
                <p>MTN, GLO, AIRTEL</p>
              </div>
            </div>
            <div class="bill-box" @click="buy_cabletv()">
              <div class="bill-box-top">
                <span class="bill-icon cable-icon"><i class="fas fa-satellite-dish icon"></i></span>
                <span class="bill-arrow"><i class="fa fa-arrow-right"></i></span>
              </div>
              <div class="bill-copy">
                <h4>Cable TV</h4>
                <p>DSTV, GOTV</p>
              </div>
            </div>
        </div>
        <div class="sub-biller-section">
          <div class="sub-biller-header">
            <p class="sub-biller-eyebrow">Electricity Billers</p>
            <h4>Select a provider directly</h4>
          </div>
          <div class="sub-biller-search">
            <i class="fa fa-search"></i>
            <input
              type="text"
              class="sub-biller-search-input"
              placeholder="Search provider by name, code or description"
              v-model="providerSearch"
            >
          </div>
          <div class="sub-biller-grid">
            <div
              class="sub-biller-card"
              v-for="biller in filteredElectricityBillers"
              :key="biller.id"
              @click="openElectricityBiller(biller.id)"
            >
              <div class="sub-biller-top">
                <span class="sub-biller-id">#{{ biller.id }}</span>
                <span class="sub-biller-code">{{ biller.billerCode }}</span>
              </div>
              <h5>{{ biller.billerName }}</h5>
              <p>{{ biller.description }}</p>
            </div>
          </div>
        </div>
       
       </div>
       <div class="pay-bills" v-if="is_transaction_history">
        <div class="transaction-history-section">
          <div class="transaction-history-header">
            <div>
              <p class="transaction-history-eyebrow">Overview</p>
              <h3><strong>Transaction History</strong></h3>
              <span>Track your recent utility payments and subscription activity in one place.</span>
            </div>
            <div class="transaction-history-count" v-if="payment_details.length">
              {{ payment_details.length }} record<span v-if="payment_details.length > 1">s</span>
            </div>
          </div>

          <div class="transaction-history-list" v-if="payment_details.length">
            <div class="transaction-card" v-for="(data, index) in payment_details" :key="index">
              <div class="transaction-card-main">
                <div class="transaction-icon">
                  <i class="fa fa-receipt"></i>
                </div>
                <div class="transaction-copy">
                  <div class="transaction-topline">
                    <span class="transaction-title">{{ formatTransactionTitle(data) }}</span>
                    <span class="transaction-badge">{{ data.utility || 'Subscription' }}</span>
                  </div>
                  <span class="transaction-meta">{{ formatTransactionMeta(data) }}</span>
                  <span class="transaction-date">{{ formatTransactionDate(data.created_at) }}</span>
                </div>
              </div>

              <div class="transaction-amount-panel">
                <span class="transaction-amount-label">Amount</span>
                <span class="transaction-amount">₦{{ data.amount }}</span>
              </div>
            </div>
          </div>

          <div class="transaction-empty-state" v-else>
            <i class="fa fa-folder-open-o"></i>
            <h4>No transactions yet</h4>
            <p>Your recent utility payments will appear here once you complete a purchase.</p>
          </div>
        </div>
       </div>

       <div class="pay-bills" v-if="is_wallet_history">
        <div class="transaction-history-section">
          <div class="transaction-history-header">
            <div>
              <p class="transaction-history-eyebrow">Overview</p>
              <h3><strong>Wallet History</strong></h3>
              <span>Track your recent wallet transfers and subscription activity in one place.</span>
            </div>
            <div class="transaction-history-count" v-if="wallet_details.length">
              {{ wallet_details.length }} record<span v-if="wallet_details.length > 1">s</span>
            </div>
          </div>

          <div class="transaction-history-list" v-if="wallet_details && wallet_details.length">
            <div class="transaction-card" v-for="(data, index) in wallet_details" :key="data.id || index">
              
              <div class="transaction-card-main">
                
                <!-- Icon -->
                <div class="transaction-icon">
                  <i :class="getTransactionIcon(data)"></i>
                </div>

                <!-- Details -->
                <div class="transaction-copy">
                  
                  <div class="transaction-topline">
                    <span class="transaction-title">
                      {{ getTransactionTitle(data) }}
                    </span>

                    <span class="transaction-badge"
                          :class="getBadgeClass(data)"
                          :style="data.wallet_detail_type === 'credit'
                            ? { backgroundColor: '#d4edda', color: '#155724' }
                            : { backgroundColor: '#f8d7da', color: '#721c24' }">
                      {{ data.wallet_detail_type === 'credit' ? 'Credit' : 'Debit' }}
                    </span>
                  </div>

                  <!-- Description -->
                  <div class="transaction-meta">
                    {{ getTransactionDescription(data) }}
                  </div>

                  <!-- Extra Info -->
                  <div class="transaction-extra-info">
                    <small v-if="data.wallet_detail_type === 'credit'">
                      Ref: {{ data.reference }} • {{ data.senderBank || 'Bank Transfer' }}
                    </small>

                    <small v-else>
                      {{ getDebitExtraInfo(data) }}
                    </small>
                  </div>

                  <!-- Date -->
                  <span class="transaction-date">
                    {{ formatTransactionDate(data.dateOfTransaction || data.created_at) }}
                  </span>
                </div>
              </div>

              <!-- Amount -->
              <div class="transaction-amount-panel">
                <span class="transaction-amount-label">
                  {{ data.wallet_detail_type === 'credit' ? 'Credited' : 'Debited' }}
                </span>

                <span class="transaction-amount"
                      :class="{
                        'positive': data.wallet_detail_type === 'credit',
                        'negative': data.wallet_detail_type === 'debit'
                      }">
                  {{ data.wallet_detail_type === 'credit' ? '+' : '-' }}
                  ₦{{ formatAmount(data.amount) }}
                </span>
              </div>

            </div>
          </div>

          <div class="transaction-empty-state" v-else>
            <i class="fa fa-folder-open-o"></i>
            <h4>No transactions yet</h4>
            <p>Your recent wallet transaction will appear here.</p>
          </div>
        </div>
       </div>

       <div class="pay-bills" v-if="is_contact_us">
        <h3>&nbsp;<strong>Contact Us</strong></h3>
        <div class="bills">
              <div class="mt-5">
                <h4><i class="fa fa-envelope" aria-hidden="true"></i> Email Us</h4>
                 <p>Our dedicated team will help you out<br><span class="text-secondary"><a href="mailto:info@plepower.com.ng" class="text-secondary">info@plepower.com.ng</a></span></p>

                 <h4 class="mt-6"><i class="fa fa-headphones" aria-hidden="true"></i> Help Desk</h4>
                 <p>You can reach out via call or sms 24/7.<br> <span class="text-secondary">+2347051525555</span></p>
              </div>
              <div style="">
                 <h4 class="mt-6"><i class="fa fa-map-marker" aria-hidden="true"></i> Our Office</h4>
                 <p>Visit us today at our office headquarter<br> <span class="text-secondary">21 Ibezim Obiajulu Street off Adelabu, Surulere, Lagos</span></p>
                 <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.169090767424!2d3.3494058731567007!3d6.500266593491928!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b8c16f9875a7f%3A0xd9f78ba0f5d4819a!2s21%20Ibezim%20Obiajulu%20St%2C%20Surulere%2C%20Lagos%20101241%2C%20Lagos!5e0!3m2!1sen!2sng!4v1738232095876!5m2!1sen!2sng" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
          </div>

       </div>

       <div v-if="isApprove">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper col-md-5" style="margin:auto">
                    <div class="row">
                        <div class="col-md-1">
                        </div>
                        <div class="col-md-10">
                            <div class="row account-content">
                                <div class="account-content-d">
                                    <div class="inputs ">
                                        <center>
                                            <h4><strong>Confirm Shipping</strong></h4>
                                            <br>
                                            <span style="font-size: 14px; font-family: Poppins">Confirm that you have shipped the item?</span>
                                        </center>
                                        <p>&nbsp;</p>
                                    </div>
                                </div>
                                <div class=" d-flex flex-row justify-content-center">
                                    <button id="submit2" class="btn btn-info" @click="shipped()">Yes I have</button> &nbsp;&nbsp;
                                    <button id="submit2" class="btn btn-secondary" @click="isApprove = false">No not yet</button>
                                </div>
                                <p>&nbsp;</p>
                            </div>
                        </div>
                        <div class="col-md-1">
                        </div>
                    </div>
                </div>
            </div>
        </transition>
       </div>

       <div v-if="isApprove1">
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper col-md-5" style="margin:auto">
                    <div class="row">
                        <div class="col-md-1">
                        </div>
                        <div class="col-md-10">
                            <div class="row account-content">
                                <div class="account-content-d">
                                    <div class="inputs ">
                                        <center>
                                            <h4><strong>Confirm Receipt</strong></h4>
                                            <br>
                                            <span style="font-size: 14px; font-family: Poppins">Have you really received this item?</span>
                                        </center>
                                        <p>&nbsp;</p>
                                    </div>
                                </div>
                                <div class=" d-flex flex-row justify-content-center">

                                    <button id="submit2" class="btn btn-info" @click="received()"
                                            v-if="!loading2">Yes I have</button> &nbsp;&nbsp;
                                        <button class="btn btn-info" type="button" disabled v-if="loading2">
                                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        </button> &nbsp;&nbsp;
                                    <button id="submit2" class="btn btn-secondary" @click="isApprove1 = false">No not yet</button>
                                </div>
                                <p>&nbsp;</p>
                            </div>
                        </div>
                        <div class="col-md-1">
                        </div>
                    </div>
                </div>
            </div>
        </transition>
       </div>
       <div v-if="isVirtualCard">
        <transition name="modal">
            <div class="vcard-modal-mask">
                <div class="modal-wrapper col-md-5" style="margin:auto">
                    <div class="row">
                        <div class="col-md-1">
                        </div>
                        <div class="col-md-10">
                            <div class="row">
                                
                               
                                <p>&nbsp;</p>
                            </div>
                        </div>
                        <div class="col-md-1">
                        </div>
                    </div>
                </div>
            </div>
        </transition>
       </div>
       
      <div v-if="isTransactionPin">
        <transition name="modal">
            <div class="pin-modal-mask">
                <div class="modal-wrapper col-md-3" style="margin:auto">
                    <div class="row">
                        <div class="col-md-0">
                        </div>
                        <div class="col-md-12">
                            <div class="row d-flex flex-column align-items-center">
                                <p class="text-black text-uppercase text-center mt-6">Create your 4-digits transaction pin</p>
                                <div class="inputs1"> 
                                    <input type="password" maxlength="4" id="text" placeholder="Enter Transaction Pin" class="form-control inputs-field1"  v-model="transaction_pin" required  ref="input1">
                                    <input type="password" maxlength="4" id="text" placeholder="Confirm Transaction Pin" class="form-control inputs-field1"  v-model="confirm_transaction_pin" required  ref="input1">
                                </div>
                                <div class="btn-inputs">
                                    <button id="submit4" class="btn btn-primary btn-block mt-4 mb-4" :disabled="isSubmitButtonDisabled"  @click="create_pin()" v-if="!loading4">Create</button>
                                    <button class="btn btn-primary btn-block mt-4 mb-4" type="button" disabled v-if="loading4">
                                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    </button>
                                    <button class="btn btn-block" @click="isTransactionPin = false">X</button>
                                    <br>
                                </div>     
                            </div>
                        </div>
                        <div class="col-md-0">
                        </div>
                    </div>
                </div>
            </div>
        </transition>
      </div>
        <p>&nbsp;</p>
      <page-loader :is-loading="isLoading"></page-loader>
  </div>
</template>
<script>
/* global process */
import swal from 'sweetalert2';
import PageLoader from '../components/PageLoader.vue'
export default {
  
  name: "HomeDashboard",
  components: {
    PageLoader
  },

  data(){
    return {
      stream: null, // Holds the media stream
        search: '',
        loading: false,
        loading2: false,
        isLoading: false,
        isLoading1: false,
        isApprove: false,
        isApprove1: false,
        isVirtualCard: false,
        isTransactionPin: false,
        tab1_view: true,
        tab2_view: false,
        isWithdrawal: false,
        isReferralWithdrawal: false,
        tab1: true,
        tab2: false,
        phone_number: '',
        email_address: '',
        dummy_email: '',
        user_id: '',
        firstname: '',
        lastname: '',
        bank_name:'',
        account_name:'',
        account_number: '',
        isAccountDetail: false,
        isAddfund: false,
        current_plan: '',
        current_plan_name: '',
        weekly_income: '',
        planid: '',
        expiry_date: '',
        expiry_status: '',
        referral_code: '',
        total_orders: '',
        referral_earnings: '',
        order_loading: false,
        referral_loading: false,
        active_loading: false,
        referral_count_loading: false,
        payment_history: false,
        payments:[],
        cummulative_earning: '',
        referral_count: 0,
        totalTasks: '',
        isWithdrawal_time: '',
        withdrawal_list: [],
        amount: '',
        active_referrals: [],
        referral_withd: '',
        img_url: process.env.VUE_APP_IMAGE_URL + '/products/',
        header: [
          {
            align: 'start',
            value: 'package',
            sortable: false,
            text: 'Package',
          },
          { value: 'amount', text: 'Amount' },
          { value: 'paymentref', text: 'Payment Ref' },
          { value: 'date', text: 'Date' },
        ],
        desserts: [],
        copyText: '',

        header2: [
        {
          align: 'start',
          value: 'product_name',
          sortable: false,
          text: 'Product',
        },
        { value: 'img', text: 'Img' },
        { value: 'order_no', text: 'Order no.' },
        { value: 'date', text: 'Date' },
        { value: 'qty', text: 'Qty' },
        { value: 'total_amount', text: 'Amount' },
        { value: 'installment', text: 'Installment' },
        { value: 'duration1', text: 'Duration' },
        { value: 'paid', text: '%Paid' },
        { value: 'buyer', text: 'Customer' },
      ],
        desserts2: [],
        withdrawalCount: 0,
        user_bank_detail: '',
        wallet_balance: 0,
        walletStatus: 'loading',
        contract_detail: [],
        is_products: false,
        active_orders: '',
        ordered_items: '',
        valid_shops: '',
        shipping: '',
        completed_contract_detail: [],
        bank_detail: [],
        payment_details: [],
        wallet_details: [],
        fullname: '',
        contractid: '',
        contract_user_payment: '',
        contract_number: '',
        pending_deposit: '',
        isShowBal: true,
        transaction_pin: '',
        confirm_transaction_pin: '',
        loading4: '',
        user_pin: '',
        is_paybills: true,
        is_transaction_history: false,
        is_wallet_history: false,
        is_contact_us: false,
        providerSearch: '',
        showFundModal: false,
        electricityBillers: [
          { id: 12, billerName: "PHCN Enugu Prepaid", billerCode: "phcnenu", description: "This is phcn enugu prepaid biller" },
          { id: 13, billerName: "PHCN Enugu Postpaid", billerCode: "phcnppenu", description: "This is phcn enugu postpaid biller" },
          { id: 15, billerName: "PHCN Eko Prepaid", billerCode: "phcneko", description: "This is phcn eko prepaid biller" },
          { id: 16, billerName: "PHCN Eko Postpaid", billerCode: "phcnppeko", description: "This is phcn eko postpaid biller" },
          { id: 19, billerName: "PHCN Jos Prepaid", billerCode: "phcnjos", description: "This is phcn jos prepaid biller" },
          { id: 20, billerName: "PHCN Jos Postpaid", billerCode: "phcnppjos", description: "This is phcn jos postpaid biller" },
          { id: 21, billerName: "PHCN Kano Prepaid", billerCode: "phcnkan", description: "This is phcn kano prepaid biller" },
          { id: 22, billerName: "PHCN Kano Postpaid", billerCode: "phcnppkan", description: "This is phcn kano postpaid biller" },
          { id: 23, billerName: "PHCN Abuja Prepaid", billerCode: "phcnabj", description: "This is phcn abuja prepaid biller" },
          { id: 24, billerName: "PHCN Abuja Postpaid", billerCode: "phcnppabj", description: "This is phcn abuja postpaid biller" },
          { id: 25, billerName: "PHCN Ibadan Prepaid", billerCode: "phcnibd", description: "This is phcn ibadan prepaid biller" },
          { id: 26, billerName: "PHCN Ibadan Postpaid", billerCode: "phcnppibd", description: "This is phcn Ibadan postpaid biller" },
          { id: 27, billerName: "PHCN Kaduna PrePaid", billerCode: "phcnkad", description: "This is phcn kaduna prepaid biller" },
          { id: 28, billerName: "PHCN Kaduna Postpaid", billerCode: "phcnppkad", description: "This is phcn Kaduna postpaid biller" },
          { id: 29, billerName: "PHCN PortHarcourt Prepaid", billerCode: "phcnphe", description: "This is phcn PortHarcourt prepaid biller" },
          { id: 30, billerName: "PHCN PortHarcourt Postpaid", billerCode: "phcnppphe", description: "This is phcn PortHarcourt postpaid biller" },
          { id: 43, billerName: "PHCN Benin Postpaid", billerCode: "phcnppben", description: "This is phcn Benin Electric Disco postpaid biller" },
          { id: 44, billerName: "PHCN Benin Prepaid", billerCode: "phcnben", description: "This is phcn Benin Electric Disco prepaid biller" },
          { id: 45, billerName: "BUA Cement", billerCode: "bua", description: "This is BUA Cement Biller" }
        ]
      };
  },

  beforeMount(){
    this.user_id = localStorage.getItem("userid");
  },

  mounted(){
     
      this.firstname = localStorage.getItem("firstname");
      this.lastname = localStorage.getItem("lastname");
      this.phone_number = localStorage.getItem("phone");
      this.email_address = localStorage.getItem("email");
      this.dummy_email = localStorage.getItem("dummy_email");
      this.user_id = localStorage.getItem("userid");
      this.referral_code = localStorage.getItem("referral_code");
      this.fullname = this.firstname +' '+ this.lastname 

      this.fetchPaymentDetails(this.user_id)
      this.fetchWalletDetails(this.user_id)
      this.fetchWalletBalanceByUserId(this.user_id)
      
  },

  created(){
        
  },

  computed: {

    cummulativeEarnings(){
      return this.total_orders + this.referral_earnings;
    },
    indexSn() {
      return this.desserts.map((d, index) => ({
          ...d,
          sn: index + 1
      }))
    },
    isSubmitButtonDisabled() {
        return (
          this.transaction_pin === '' ||
          this.confirm_transaction_pin === ''
        );
    },
    walletActionLabel() {
      return this.walletStatus === 'missing' ? 'Create Wallet' : 'View Wallet';
    },
    walletStatusMessage() {
      if (this.walletStatus === 'missing') {
        return 'Create a wallet to get your transfer account details for incoming payments.';
      }

      return 'Use your generated transfer account to fund your wallet and pay bills easily.';
    },
    filteredElectricityBillers() {
      const search = this.providerSearch.trim().toLowerCase();

      if (!search) {
        return this.electricityBillers;
      }

      return this.electricityBillers.filter((biller) =>
        biller.billerName.toLowerCase().includes(search) ||
        biller.billerCode.toLowerCase().includes(search) ||
        biller.description.toLowerCase().includes(search) ||
        String(biller.id).includes(search)
      );
    }
  },

  methods: {

  closeFundModal() {
    this.showFundModal = false;
  },
    // Determine if it's a credit (NIP transfer) or debit (purchase)
    // Determine if transaction is Credit or Debit
  isCredit(data) {
    return data.source === 'NIP' || 
           data.transaction_type === 'CREDIT' || 
           !!data.senderName;
  },

  getTransactionTitle(data) {
    if (this.isCredit(data)) {
      return data.senderName 
        ? `${this.truncateName(data.senderName)}` 
        : 'NIP Credit';
    }
    // Debit (Airtime, Data, Electricity, etc.)
    return data.description 
      ? this.extractServiceName(data.description) 
      : 'Purchase';
  },

  getTransactionType(data) {
    return this.isCredit(data) ? 'Transfer' : 'Purchase';
  },

  getBadgeClass(data) {
    return this.isCredit(data) ? 'badge-credit' : 'badge-debit';
  },

  getTransactionIcon(data) {
    return this.isCredit(data) 
      ? 'fa fa-arrow-circle-down text-success' 
      : 'fa fa-arrow-circle-up text-danger';
  },

  getTransactionDescription(data) {
    if (this.isCredit(data)) {
      return data.senderName || 'Bank Transfer from ' + (data.senderAccountNumber || 'Unknown Bank');
    }
    return data.description || 'Service Purchase';
  },

  // Extract useful info from long electricity/airtime description
  getDebitExtraInfo(data) {
    if (!data.description) return '';

    const desc = data.description.toUpperCase();

    if (/(TOKEN|PREPAID|PHCN|ELECTRICITY)/.test(desc)) {
      return 'Electricity subscription for ' + (data.accountNumber || 'Unknown Account') + (' via ' + data.senderBank);
    }

    if (/AIRTIME|TOPUP/.test(desc)) {
      return  data.senderBank + ' subscription for ' + (data.accountNumber || 'Unknown Number');
    }

    if (/DATA|BUNDLE/.test(desc)) {
      return data.senderBank + ' subscription for ' + (data.accountNumber || 'Unknown Number');
    }

    if (/CABLETV/.test(desc)) {
      return data.senderBank + ' for ' + (data.accountNumber || 'Unknown Number');
    }


    return '';
  },

  // Truncate long names
  truncateName(name) {
    if (!name) return '';
    return name.split(' ').slice(0, 3).join(' ');
  },

  // Try to extract service name from messy description
  extractServiceName(desc) {
    if (!desc) return 'Purchase';
    if (desc.includes('PHCN') || desc.includes('PrePaid')) return 'Electricity';
    if (desc.includes('AIRTIME')) return 'Airtime';
    if (desc.includes('DATA')) return 'Data Bundle';
    return desc.substring(0, 40) + '...';
  },

  formatAmount(amount) {
    return Number(amount || 0).toLocaleString('en-NG');
  },

  formatTransactionDate(dateString) {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString('en-NG', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  },
    pay_bills(){
      this.is_paybills = true
      this.is_transaction_history = false
      this.is_contact_us = false
      this.is_wallet_history = false
    },
    transaction_history(){
      this.is_transaction_history = true
      this.is_paybills = false
      this.is_contact_us = false
      this.is_wallet_history = false
    },
    wallet_history(){
      this.is_wallet_history = true
      this.is_transaction_history = false
      this.is_paybills = false
      this.is_contact_us = false
    },
    contact_us(){
      this.is_contact_us = true
      this.is_transaction_history = false
      this.is_paybills = false
      this.is_wallet_history = false
    },
    formatCurrency(amount) {
      const normalizedAmount = Number(amount || 0);
      return new Intl.NumberFormat('en-NG', {
        style: 'currency',
        currency: 'NGN',
        minimumFractionDigits: 2
      }).format(normalizedAmount);
    },
    formatTransactionDate(date) {
      if (!date) {
        return 'Date unavailable';
      }

      return new Date(date).toLocaleString('en-NG', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
      });
    },
    formatTransactionTitle(data) {
      const network = data.network || 'Utility';
      const utility = data.utility ? ` (${data.utility})` : '';
      return `${network}${utility}`;
    },
    formatTransactionMeta(data) {
      const parts = [];

      if (data.mobile_phone) {
        parts.push(data.mobile_phone);
      }

      if (data.purchase_item) {
        parts.push(data.purchase_item);
      }

      return parts.join(' | ') || 'Subscription payment';
    },
    async startCamera() {
      try {
        // Request camera access
        this.stream = await navigator.mediaDevices.getUserMedia({ video: true });

        // Assign the stream to the video element
        const videoElement = this.$refs.video;
        videoElement.srcObject = this.stream;
      } catch (error) {
        console.error("Error accessing camera:", error);
        alert("Could not access the camera. Please allow permissions.");
      }
    },
    async fetch_user_pin(){
      try {
              const response = await this.$http.post('/fetch-pin', {
                user_id: this.user_id
              })         
              this.user_pin = response.data.data  
              // load create transaction pin page if user not having pin
              if (!this.user_pin) {
                this.isTransactionPin = true
              }  

          } catch (err) {
              console.log(err);
          }
    },
    async create_pin(){
      try {
              if (this.transaction_pin != this.confirm_transaction_pin) {
                swal.fire({
                    icon: 'warning',
                    title: 'Pin Creation',
                    width: 450,
                    height: 5,
                    text: 'Transaction pin does not match',
                })
                return;
              }
              this.loading4 = true
              const response = await this.$http.post('/create-pin', {
                transaction_pin: this.transaction_pin,
                confirm_transaction_pin: this.confirm_transaction_pin,
                user_id: this.user_id
              })
              this.loading4 = false
              if (response.data.success) {
                swal.fire({
                        icon: 'success',
                        title: 'Success',
                        width: 450,
                        height: 5,
                        text: response.data.message,
                    })
                    this.isTransactionPin = false
                    return;
                }
                else if (!response.data.success) {
                    swal.fire({
                        icon: 'error',
                        title: 'Error',
                        width: 450,
                        height: 5,
                        text: 'Could not create pin. An error occured!',
                    })
                    return;
                }  
             
          } catch (err) {
              console.log(err);
          }
    },
    buy_airtime(){
     this.$router.push('/airtime/purchase')
     //alert("Coming soon")
    },
    buy_data(){
      this.$router.push('/data/purchase')
      //alert("Coming soon")
    },
    buy_electricity(){
      //alert("Coming soon")
      this.$router.push('/electricity/purchase')
    },
    openElectricityBiller(id){
      this.$router.push({ path: '/electricity/purchase', query: { billerId: id } })
    },
    buy_cabletv(){
      this.$router.push('/cable-tv/purchase')
      //alert("Coming soon")
    },
    toggle(){
       if (this.isShowBal) {
        this.isShowBal = false
       }
       else{
        this.isShowBal = true
       }
    },

    async handleWalletAction(account_number) {
  try {
    // Step 1: Input form
    const { value: formValues } = await swal.fire({
      title: 'Transfer Funds',
       html: `
  <div style="font-family: Inter, system-ui; text-align:left; padding-top:5px;">

    <!-- From Account -->
    <div style="margin-bottom:18px;">
      <div style="font-size:11px; color:#9ca3af; margin-bottom:4px;">
        FROM
      </div>
      <div style="font-size:15px; font-weight:600; color:#111827;">
        ${account_number}
      </div>
    </div>

    <!-- To Account -->
    <div style="margin-bottom:18px;">
      <div style="font-size:11px; color:#9ca3af; margin-bottom:6px;">
        TO ACCOUNT
      </div>
      <input id="swal-to" placeholder="Enter recipient account"
        style="
          width:100%;
          border:none;
          border-bottom:1px solid #e5e7eb;
          padding:10px 2px;
          font-size:15px;
          outline:none;
        ">
    </div>

    <!-- Amount -->
    <div style="margin-bottom:20px;">
      <div style="font-size:11px; color:#9ca3af; margin-bottom:6px;">
        AMOUNT
      </div>
      <div style="display:flex; align-items:center;">
        <span style="font-size:22px; font-weight:600; color:#111827; margin-right:4px;">
          ₦
        </span>
        <input id="swal-amount" type="number" placeholder="0.00"
          style="
            width:100%;
            border:none;
            border-bottom:1px solid #e5e7eb;
            padding:10px 2px;
            font-size:22px;
            font-weight:600;
            outline:none;
          ">
      </div>
    </div>

    <!-- Remark -->
    <div style="margin-bottom:5px;">
      <div style="font-size:11px; color:#9ca3af; margin-bottom:6px;">
        REMARK
      </div>
      <input id="swal-remark" placeholder="Add a note (optional)"
        style="
          width:100%;
          border:none;
          border-bottom:1px solid #e5e7eb;
          padding:10px 2px;
          font-size:14px;
          outline:none;
        ">
    </div>

  </div>
`,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: 'Continue',
      confirmButtonColor: '#2563eb',
      preConfirm: () => {
        const fromAccount = account_number; //trust param
        const toAccount = document.getElementById('swal-to').value.trim();
        const amount = document.getElementById('swal-amount').value.trim();
        const remark = document.getElementById('swal-remark').value.trim();

        if (!toAccount || !amount) {
          swal.showValidationMessage('All fields are required');
          return false;
        }

        if (Number(amount) <= 0) {
          swal.showValidationMessage('Amount must be greater than 0');
          return false;
        }

         if (Number(amount) > Number(this.wallet_balance)) {
          swal.showValidationMessage('Insufficient wallet balance');
          return false;
        }

        return { fromAccount, toAccount, amount, remark };
      }
    });

    if (!formValues) return;

    // Step 2: Confirm transfer
    const confirmation = await swal.fire({
      icon: 'question',
      title: 'Confirm Transfer',
      text: `Transfer ₦${formValues.amount} to ${formValues.toAccount}?`,
      showCancelButton: true,
      confirmButtonText: 'Yes, Transfer',
      confirmButtonColor: '#2563eb'
    });

    if (!confirmation.isConfirmed) return;

    // Step 3: PIN input
    const { value: pin } = await swal.fire({
      title: 'Enter Transaction PIN',
      input: 'password',
      inputPlaceholder: 'Enter your PIN',
      inputAttributes: {
        autocapitalize: 'off',
        autocorrect: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Authorize',
      confirmButtonColor: '#2563eb',
      preConfirm: (value) => {
        if (!value) {
          swal.showValidationMessage('PIN is required');
          return false;
        }

        return value;
      }
    });

    if (!pin) return;

    // Step 4: Call API
    this.loading = true;

    const response = await this.$http.post('/embedly/wallet-to-wallet-transfer', {
      userId: this.user_id,
      fromAccount: formValues.fromAccount,
      toAccount: formValues.toAccount,
      amount: formValues.amount,
      remarks: formValues.remark,
      pin: pin,
      phone: this.phone_number
    });

    this.loading = false;

    if (response.data && response.data.success) {
      swal.fire({
        icon: 'success',
        title: 'Transfer Successful',
        text: response.data.message || 'Funds transferred successfully.'
      });

      this.fetchWalletBalanceByUserId(this.user_id);
      return;
    }

    swal.fire({
      icon: 'warning',
      title: 'Warning',
      text: response.data?.message || 'Transfer failed.'
    });

  } catch (err) {
    this.loading = false;
    console.log(err);

    swal.fire({
      icon: 'error',
      title: 'Transfer Error',
      text: err.response ? err.response.data.message : err.message
    });
  }
},

    async create_wallet(){
      try {
        const confirmation = await swal.fire({
          icon: 'question',
          title: 'Create Wallet?',
          width: 450,
          height: 5,
          text: 'Do you want to create a wallet now?',
          showCancelButton: true,
          confirmButtonText: 'Yes, create wallet',
          cancelButtonText: 'Cancel',
          confirmButtonColor: '#2563eb',
          cancelButtonColor: '#6b7280'
        })

        if (!confirmation.isConfirmed) {
          return
        }

        this.loading = true

        const response = await this.$http.post('/embedly/create-customer', {
          userId: this.user_id,
          firstName: this.firstname || '',
          lastName: this.lastname || '',
          middleName: this.middleName || '',
          emailAddress: this.email_address || this.dummy_email || '',
          mobileNumber: this.phone_number || ''
        })

        this.loading = false

        if (response.data && response.data.success) {
          swal.fire({
            icon: 'success',
            title: 'Wallet Created',
            width: 450,
            height: 5,
            text: response.data.message || 'Your wallet has been created successfully.'
          })
          this.fetchWalletBalanceByUserId(this.user_id)
          return
        }

        swal.fire({
          icon: 'warning',
          title: 'Warning',
          width: 450,
          height: 5,
          text: response.data && response.data.message ? response.data.message : 'Could not create wallet right now.'
        })
      } catch (err) {
        this.loading = false
        console.log(err)
        swal.fire({
          icon: 'error',
          title: 'Wallet Creation Failed',
          width: 450,
          height: 5,
          text: 'Something went wrong while creating the wallet.'
        })
      }
    },

    view_wallet_history(){
      this.$router.push('/wallet')
    },

    copyToClipboard1(link) {
        navigator.clipboard.writeText(link).then(function() {
            alert("Contract link copied to clipboard!");
        }).catch(function(err) {
            console.error('Failed to copy: ', err);
        });
    },

    async fetchWalletBalanceByUserId(userid) {
            try {
              this.isLoading = true
              this.walletStatus = 'loading'
              this.desserts = []
               const response =  await this.$http.post('/fetch-wallet-balance', {
                  userid: userid
                })
              this.isLoading = false
              const balance = response && response.data ? response.data.balance : undefined
              const bank_name = response && response.data ? response.data.bankName : undefined
              const account_number = response && response.data ? response.data.accountNumber : undefined
              const account_name = response && response.data ? response.data.accountName : undefined
              const hasWallet = balance !== undefined && balance !== null && balance !== ''

               if (
                  this.wallet_balance === Number(balance || 0) ||
                  Number(balance || 0) < 1000
                ) {
                  this.showFundModal = true;
                }

              if (hasWallet) {
                this.wallet_balance = Number(balance || 0)
                this.bank_name = bank_name
                this.account_name = account_name
                this.account_number = account_number
                this.walletStatus = 'ready'
                return
              }

              this.wallet_balance = 0
              this.walletStatus = 'missing'

             
               
            } catch (err) {
              this.isLoading = false
              const walletErrorMessage = String(
                (err && err.response && err.response.data && err.response.data.message) ||
                (err && err.response && err.response.data && err.response.data.error) ||
                ''
              ).toLowerCase()

              if ((err && err.response && err.response.status === 404) || walletErrorMessage.includes('wallet')) {
                this.wallet_balance = 0
                this.walletStatus = 'missing'
                return
              }

              this.walletStatus = 'ready'
              console.log(err);
          }
    },

    async validateBank(userid) {
            try {

               const response =  await this.$http.post('/fetch-user-bank', {
                  userid: userid,
                })

                this.user_bank_detail = response.data.bank
                    
            } catch (err) {
              console.log(err);
          }
    },

    async fetchPaymentDetails(userid){
      try {
            this.isLoading = true
            const response =  await this.$http.post('/fetch-utility-transactions-by-userid', {
              userid: userid,
            })
            this.payment_details = response.data.data;
            this.isLoading = false
            return;
            
      } catch (err) {
          console.log(err);
      }
    },
    
    async fetchWalletDetails(userid){
      try {
            this.isLoading = true
            const response =  await this.$http.post('/fetch-wallet-details', {
              userid: userid,
            })
            this.wallet_details = response.data.data;
            this.isLoading = false
            return;
            
      } catch (err) {
          console.log(err);
      }
    },
 
    async paymentHistory() {
      try {
            this.payment_history = true
            const response =  await this.$http.post('/payment-history', {
                userid: this.user_id
            })
            this.payment_history = false
            this.payments = response.data.payments;
            this.payments.forEach(el => {
            this.desserts.push({
              package: el.plan_name,
              amount: 'NGN'+el.amount.toLocaleString('en-NG', { minimumIntegerDigits: 2 }),
              paymentref: el.payment_ref,
              date: new Date(el.created_at).toDateString()
            })
          }); 
        } catch (err) {
          console.log(err);
      }
    },
   
    viewTab1(){
      this.tab1_view = true
      this.tab2_view = false
    },

    viewTab2(){
      this.tab1_view = false
      this.tab2_view = true
    },

    copyToClipboard(text) {
      navigator.clipboard.writeText(text)
        .then(() => {
          this.copyText = 'Account number copied!'; // Store the copied text if needed
        })
        .catch((err) => {
          console.error('Failed to copy:', err);
        });
    },
 
  }
}
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;700&display=swap');
.account-number-copy {
  display: flex;
  align-items: center;
  gap: 8px;
}

.copy-icon {
  cursor: pointer;
  font-size: 14px;
  color: #6b7280;
  transition: color 0.2s ease;
}

.copy-icon:hover {
  color: #111827;
}
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.custom-modal-box {
  background: #fff;
  width: 100%;
  max-width: 400px;
  border-radius: 18px;
  padding: 30px 25px;
  text-align: center;
  animation: popup 0.3s ease;
}

.modal-icon {
  width: 70px;
  height: 70px;
  background: #eef4ff;
  color:#155724;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  font-size: 28px;
}

.modal-message {
  color: #666;
  line-height: 1.6;
  margin-top: 10px;
  margin-bottom: 25px;
}

.modal-btn {
  background:#24562B;
  color: #fff;
  border: none;
  padding: 12px 25px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 15px;
  width: 100%;
}

.modal-btn:hover {
  opacity: 0.9;
}

@keyframes popup {
  from {
    transform: scale(0.8);
    opacity: 0;
  }

  to {
    transform: scale(1);
    opacity: 1;
  }
}

.transaction-amount.positive { color: #28a745; font-weight: bold; }
.transaction-amount.negative { color: #dc3545; font-weight: bold; }

.transaction-extra-info small {
  color: #666;
  font-size: 12.5px;
  display: block;
  margin-top: 3px;
}
@media screen and (max-width: 768px) {
  .transaction-extra-info small {
    font-size: 10.5px
  }
}
.container-fluid{
  background: #cccccc41;
  border-radius: 10px;
  //padding: 0 40px 0 15rem;
  min-height: 100vh;
}
.fa-eye{
  cursor: pointer;
  //font-size: 10px;
}
.copy-refid1{
  cursor: pointer;
  //font-size: 20px;
}

.pin-modal-mask {
  position: fixed;
  //z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .4s ease;

  &>div {
      width: 80%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      backdrop-filter: blur(13px);
      border-radius: 10px;
      box-sizing: border-box;
      font-family: Poppins;
  }

}
.inputs1{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  border-radius: 3px;
  font-size:11px;
  font-weight: 400;
  width: 100%;
  padding: 0.6rem;

  .inputs-field1{
      font-size: 14px;
      font-weight: bold;
      font-family: Poppins;
      text-align: center;
      height: 40px;
      margin: 5px;
      border: solid 1px;
  }
}
.btn-primary1{

  border-radius: 9px;
  background: #24562B;
  color: #fff;
  text-transform: uppercase;
  //font-family: Montserrat;
  font-size: 12px;
  font-weight: 500;
}
.btn-primary{
  width: 100%;
  height: 52px;
  padding: 0px 36.19px 0px 36.19px;
  border-radius: 9.05px;
  background: #24562B;
  color: #fff;
  text-transform: uppercase;
  font-family: Montserrat;
  font-size: 15px;
  font-weight: 700;
}
.modal-mask {
  position: fixed;
  //z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .4s ease;

  &>div {
      width: 90%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      ;
      backdrop-filter: blur(13px);
      border-radius: 10px;
      box-sizing: border-box;
      font-family: Poppins;
  }

  h3 {
      margin-top: 10px;
      font-size: 18px;
      color: #000;
      font-weight: bold;
      font-family: Poppins;
  }
}
.vcard-modal-mask {
  position: fixed;
  //z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .4s ease;

  &>div {
      width: 90%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      ;
      backdrop-filter: blur(13px);
      border-radius: 10px;
      box-sizing: border-box;
      font-family: Poppins;
  }

  h3 {
      margin-top: 10px;
      font-size: 18px;
      color: #000;
      font-weight: bold;
      font-family: Poppins;
  }
}
.search-bar{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 20px 0px 20px;
}

.account-summary{
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  gap: 1rem;
  padding: 0 35px 1rem;
}
.wallet-overview-card,
.account-details-card{
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
  padding: 1.3rem 1.4rem;
  border-radius: 22px;
  border: 1px solid rgba(25, 63, 48, 0.08);
  box-shadow: 0 18px 48px rgba(7, 30, 22, 0.08);
}
.wallet-overview-card{
  background: linear-gradient(135deg, #16372d 0%, #24562B 100%);
  color: #fff;
}

@media screen and (max-width: 768px) {
  .wallet-overview-card,
  .account-details-card{
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
    padding: 1.3rem 1.4rem;
    border-radius: 22px;
    border: 1px solid rgba(25, 63, 48, 0.08);
    box-shadow: 0 18px 48px rgba(7, 30, 22, 0.08);
    width: 100%;
  }

  .account-detail-item{
    width: 100%;
  }
  
}
.account-details-card{
  background: linear-gradient(180deg, #ffffff 0%, #f7faf8 100%);
}
.wallet-overview-top{
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;

  h3{
    margin: 0.2rem 0 0;
    font-size: 30px;
    font-weight: 700;
    color: #fff;
    font-family: Poppins;
  }
}
.wallet-overview-meta{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  span{
    font-size: 12px;
    color: rgba(255,255,255,0.8);
    font-family: Poppins;
  }
}
.summary-eyebrow{
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-family: Poppins;
  color: #9fbcaa;
}
.account-details-card .summary-eyebrow{
  color: #659610;
}
.account-details-card h4{
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  color: #16372d;
  font-family: Poppins;
}
.account-detail-grid{
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}
.account-detail-item{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.3rem;
  padding: 0.9rem 1rem;
  border-radius: 16px;
  background: #f4f8f5;

  strong{
    font-size: 14px;
    color: #16372d;
    font-family: Poppins;
    word-break: break-word;
  }
}
.the-copy-icon {
  margin-top: 10px;
  margin-left: -60px;

  width: 40px;
  height: 40px;

  border-radius: 50%;
  background: #0d220585;

  border: 1px solid #fff;

  display: flex;
  align-items: center;
  justify-content: center;
}

.the-copy-icon .copy-icon {
  font-size: 20px;
  color: #fff;
  transition: color 0.2s ease;
}
@media screen and (max-width: 768px) {
  .the-copy-icon{
    margin-top: -70px;
    margin-left: auto;
  }
}
.detail-label{
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #7a8b85;
  font-family: Poppins;
}
.summary-action,
.summary-link{
  border: 0;
  border-radius: 999px;
  font-family: Poppins;
  font-size: 10px;
  font-weight: 700;
}
.summary-action{
  padding: 0.75rem 1rem;
  background: #ffffff;
  color: #24562B;
}
.summary-link{
  padding: 0;
  background: transparent;
  color: #ffffff;
  //text-decoration: underline;
  text-underline-offset: 3px;
}
.create-wallet-inline{
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  align-self: flex-start;
  border: 0;
  border-radius: 999px;
  padding: 0.65rem 1rem;
  background: #24562B;
  color: #fff;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 700;
  box-shadow: 0 12px 24px rgba(36, 86, 43, 0.16);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.create-wallet-inline:hover{
  transform: translateY(-1px);
  box-shadow: 0 16px 28px rgba(36, 86, 43, 0.2);
}
.create-wallet-inline:disabled{
  cursor: not-allowed;
  opacity: 0.8;
  transform: none;
  box-shadow: 0 12px 24px rgba(36, 86, 43, 0.12);
}
.wallet-inline-spinner{
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.35);
  border-top-color: #fff;
  border-radius: 50%;
  display: inline-block;
  animation: wallet-spin 0.8s linear infinite;
}
@keyframes wallet-spin {
  to {
    transform: rotate(360deg);
  }
}

.inputs-panel{
  display: flex;
  flex-direction: column;
  height: 48px;
  border-radius: 102px;

}
.input-field{
  border-right: 1px solid #B7BFC5;
}
.account-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.account-content-h {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  margin: 10px;
  padding-top: 1.3rem;
  text-transform: uppercase;
  text-align: center;
}

.add-fund {
  font-size: 12px;
  text-decoration: none !important;
  text-transform: capitalize;
}

.account-content-d {
  padding-top: 1.3rem;
  font-size: 14px;
  margin-bottom: 10px;
}

.btn-secondary {
  text-transform: normal;
  background: #24562B;
  color: #fff;
  border-radius: 8px;
}
.btn-info {
  text-transform: normal;
  background: #24562B;
  color: #fff;
  border-radius: 8px;
}
.btn-primary {
  text-transform: normal;
  background: #24562B;
  color: #fff;
  border-radius: 8px;
}
.top-menu{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 14px 25px;
  color:#24562B;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(25, 63, 48, 0.08);
  border-radius: 22px;
  box-shadow: 0 18px 48px rgba(7, 30, 22, 0.06);
  margin: 0 20px;
}
.top-brand{
  display: flex;
  align-items: center;
  gap: 0.8rem;

  img{
    width: 48px;
    height: 48px;
    object-fit: contain;
  }
}
.top-brand-copy{
  display: flex;
  flex-direction: column;
  gap: 0.1rem;

  strong{
    font-size: 16px;
    color: #16372d;
    font-family: Poppins;
  }

  span{
    font-size: 11px;
    color: #789085;
    font-family: Poppins;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }
}
.menu{
  display: flex;
  align-items: center;
  gap: 0.65rem;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 400;
  color:#24562B
}
.menu-link{
  border: 0;
  background: transparent;
  color: #4f645c;
  font-family: Poppins;
  font-size: 13px;
  font-weight: 600;
  padding: 0.75rem 1rem;
  border-radius: 999px;
  transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
}
.menu-link.active{
  background: linear-gradient(135deg, #24562B 0%, #2f6c37 100%);
  color: #fff;
  box-shadow: 0 10px 24px rgba(36, 86, 43, 0.22);
}
.menu-link:hover{
  background: #eef5ef;
  color: #24562B;
}
.marquee{
  position: relative;
  overflow: hidden;
  margin: 0 35px 10px;
  padding: 0.85rem 0;
  border-radius: 18px;
  background: linear-gradient(135deg, #16372d 0%, #24562B 100%);
  box-shadow: 0 16px 40px rgba(7, 30, 22, 0.12);
}
.marquee-track{
  display: flex;
  width: max-content;
  animation: dashboardTicker 22s linear infinite;
}
.marquee-content{
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-right: 2rem;
  white-space: nowrap;
}
.marquee-badge{
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.85rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-family: Poppins;
}
.marquee-text{
  color: rgba(255, 255, 255, 0.92);
  font-size: 13px;
  font-weight: 500;
  font-family: Poppins;
}
.marquee-separator{
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.45);
}
@keyframes dashboardTicker {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}
.pay-bills{
  display: flex;
  flex-direction: column;
  padding: 10px 35px;
  h3{
  font-family: Poppins;
  font-size: 16px;
  font-weight: 400;
  }
}
.pay-bills-header{
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 0.9rem;

  h3{
    margin: 0;
    font-family: Poppins;
    font-size: 22px;
    font-weight: 700;
    color: #112e25;
  }

  span{
    font-size: 13px;
    color: #6b7b75;
    font-family: Poppins;
  }
}
.pay-bills-eyebrow{
  margin: 0 0 0.25rem;
  color: #659610;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 11px;
  font-weight: 700;
  font-family: Poppins;
}
.bills{
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}
.bill-box{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.2rem;
  min-height: 180px;
  width: 100%;
  border: 1px solid rgba(25, 63, 48, 0.08);
  border-radius: 22px;
  background: linear-gradient(180deg, #ffffff 0%, #f7faf8 100%);
  box-shadow: 0 18px 48px rgba(7, 30, 22, 0.08);
  margin: 0;
  cursor: pointer;
  transition: transform 0.22s ease, box-shadow 0.22s ease;
  h4{
    margin: 0;
    font-size: 15px; 
  }
}
.bill-box:hover{
  transform: translateY(-6px);
  box-shadow: 0 24px 56px rgba(7, 30, 22, 0.14);
}
.bill-box-top{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bill-icon{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 18px;
  color: #fff;
  font-size: 22px;
}
.electricity-icon{
  background: linear-gradient(135deg, #f2b632 0%, #d99311 100%);
}
.airtime-icon{
  background: linear-gradient(135deg, #e85b4f 0%, #c6362b 100%);
}
.data-icon{
  background: linear-gradient(135deg, #1669b2 0%, #0a3d67 100%);
}
.cable-icon{
  background: linear-gradient(135deg, #7b4db6 0%, #4e2f7d 100%);
}
.bill-arrow{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #eef4ef;
  color: #24562B;
  font-size: 12px;
}
.bill-copy{
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-top: 1.2rem;

  h4{
    font-size: 22px;
    font-weight: 700;
    color: #16372d;
    font-family: Poppins;
  }

  p{
    margin: 0;
    color: #62746d;
    font-size: 13px;
    font-family: Poppins;
    letter-spacing: 0.02em;
  }
}
.sub-biller-section{
  margin-top: 1.6rem;
}
.sub-biller-header{
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-bottom: 0.9rem;

  h4{
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #16372d;
    font-family: Poppins;
  }
}
.sub-biller-eyebrow{
  margin: 0;
  color: #659610;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 11px;
  font-weight: 700;
  font-family: Poppins;
}
.sub-biller-grid{
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.9rem;
}
.sub-biller-search{
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  i{
    position: absolute;
    left: 14px;
    color: #7a8b85;
    font-size: 13px;
  }
}
.sub-biller-search-input{
  width: 100%;
  height: 48px;
  padding: 0.75rem 1rem 0.75rem 2.5rem;
  border-radius: 16px;
  border: 1px solid rgba(25, 63, 48, 0.1);
  background: #ffffff;
  color: #16372d;
  font-size: 13px;
  font-family: Poppins;
  box-shadow: 0 10px 28px rgba(7, 30, 22, 0.05);
}
.sub-biller-search-input:focus{
  outline: none;
  border-color: #24562B;
  box-shadow: 0 12px 28px rgba(36, 86, 43, 0.12);
}
.sub-biller-card{
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  padding: 1rem;
  border-radius: 18px;
  background: #ffffff;
  border: 1px solid rgba(25, 63, 48, 0.08);
  box-shadow: 0 14px 35px rgba(7, 30, 22, 0.06);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  h5{
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: #16372d;
    font-family: Poppins;
  }

  p{
    margin: 0;
    font-size: 12px;
    line-height: 1.6;
    color: #62746d;
    font-family: Poppins;
  }
}
.sub-biller-card:hover{
  transform: translateY(-4px);
  box-shadow: 0 18px 42px rgba(7, 30, 22, 0.1);
}
.sub-biller-top{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}
.sub-biller-id{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  padding: 0.35rem 0.6rem;
  border-radius: 999px;
  background: #eef5ef;
  color: #24562B;
  font-size: 11px;
  font-weight: 700;
  font-family: Poppins;
}
.sub-biller-code{
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #7a8b85;
  font-family: Poppins;
}
.notices{
  display: flex;
  flex-direction: column;
  font-family: Mulish;
  font-size: 17px;
}
.notice-board{
  background: #fff;
 
  color: #000;
  margin: 10px;
  padding: 0 0 0 20px;
  border-radius: 4px;
}
.border-bottom{
  margin: 0 30px 0 30px;
  border-bottom: solid 1.5px #24562B;
}
.marquee{
  margin: 0 30px 0 30px;
  background: #24562b82;
  color: #000;
}
.welcome{
  font-family: Poppins;
  font-size: 17px;
  font-weight: 500;
  padding: 0px 15px;
  text-align: left;
  color: #000;
}
.welcome1{
  font-family: Poppins;
  font-size: 12px;
  font-weight: 400;
  padding: 0px 15px;
  text-align: left;
  color: #000;
  margin-top: -10px;
}

.dashboard-page{
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    background: #cccccc32;
    padding: 0.6rem;
    font-family: Poppins;

    strong{
      font-weight: normal;
      font-family: Poppins;
    }
 }

 .wallet-board{
    display: flex;
    flex-direction: row;
    justify-content:space-between;
    align-items: center;
    border-radius: 4px;
    padding: 0.5rem;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3); 
    height: 100%;
 }

 .wallet-account{
  display: flex;
  flex-direction: column;
  width: 40%;
  height: 100%;
  background: #24562B;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
 }
 .account-note{
  border-bottom: solid 1px #ccc;
  padding: 0.6rem;

    p{
      font-family: Poppins;
      font-weight: normal;
      font-size: 11px;
      line-height: 1.2;
      color: #ccc;
    }

 }
 .account-number{
    padding: 0.6rem;
  
  div{
    font-family: Poppins;
    font-weight: normal;
    font-size: 10px;
    color: #ccc;

    span{
      color: #fff;
    }
  }
 }
 .wallet-balance{
    display: flex;
    flex-direction: column;
    justify-content:center;
    align-items: center;
    width: 60%;
    height: 100%;
    //background-image: linear-gradient(-90deg, #fff, #cccccc56, #fff);
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    
    h4{
      font-family: Poppins;
      font-weight: 600;
      font-size: 20px;
      color: #000;
      text-shadow: 1px 0px 1px #ccc;
    }
 }
 .withdrawal{
    font-family: Poppins;
    font-weight: normal;
    font-size: 12px;
    color: #24562B;
    border: solid 1px;
    padding: 0.2rem;
    border-radius: 4px;
 }
 .dashboard-inner{
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 320px;
  padding: 18px 20px 18px 20px;
  border-radius: 16px;
  border: 3px solid #F4F4F4;
  background: var(--White-Original, #FFFFFF);
  scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
 }
 .dashboard-inner1{
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  padding: 18px 20px 18px 20px;
  border-radius: 16px;
  border: 0px solid #F4F4F4;
  background: var(--White-Original, #FFFFFF);
  scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
  margin-top:-10px;
 }
 .sidebar::-webkit-scrollbar {
  display: none;
}

.active-escrow{
  font-size: 15px;
  font-weight: 600;
  line-height: 15px;
  text-align: left;
}
.create-escrow{
  display: flex;
  flex-direction: row;
  justify-content:center;
  align-items: center;
  width: 130px;
  height: 30px;
  padding: 0.8rem;
  border-radius: 70.8px;
  background: var(--Primary-Color, #24562B);
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer
}
 .dashboard-inner-new{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 255px;
  padding: 18px 20px 18px 20px;
  gap: 10px;
  border-radius: 16px;
  border: 3px solid #F4F4F4;
  background: var(--White-Original, #FFFFFF);
 }
 .wallet-board-new{
  display: flex;
  flex-direction: column;
 
  width: 100%;
  height: auto;
  padding: 0.9rem;
  border-radius: 13px;
  
  background: var(--Primary-Color, #24562B);
  color: #fff;

  .avail-amount{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    
    width: 100%;

    .avail-bal{
      //font-family: Montserrat;
      font-size: 12px;
      font-weight: 400;
    }
    .trans-his{
      //font-family: Montserrat;
      font-size: 12px;
      font-weight: 400;
      color: #D9D9D9;
    }

  }
  .tran-history{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .balance{
      font-size: 32px;
      font-weight: 400;
      text-align: left;
      display: flex;
    }
    .balance2{
      font-size: 32px;
      font-weight: 400;
      text-align: left;
      display: none;
    }
   .pending-history{
    display: flex;
    flex-direction: column;
   }
    .pending{
      //font-family: Montserrat;
      font-size: 10px;
      font-weight: 500;
      text-align: left;
      color: #D9D9D9;
    }
  }
 }
 .add-withd-panel{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
 }
 .add-fund{
  width: Fixed (111.7px)px;
  height: Fixed (38px)px;
  padding: 12.67px 16.12px 12.67px 16.12px;
  gap: 11.52px;
  border-radius: 81.53px;
  
  background: var(--Primary-Color, #24562B);
  //font-family: Inter;
  font-size: 12.79px;
  font-weight: 500;
  line-height: 12.79px;
  text-align: left;
  color: #FFFFFF;
  margin-right: 4px;

 }
 .withd-fund{
  width: Fixed (112.59px)px;
  height: Hug (38px)px;
  padding: 12.67px 9.85px 12.67px 9.85px;
  gap: 14.07px;
  border-radius: 81.53px;
  
  background: var(--Secondary-color, #08294A);
  //font-family: Inter;
  font-size: 12.79px;
  font-weight: 500;
  line-height: 12.79px;
  text-align: left;
  color: #FFFFFF;

 }
 .active-c{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #ECF3FF;
  width: 100%;
  height: 100px;
  border-radius: 12px;

  .icon{
    font-size: 44px;
  }
 }
 .active-c-history{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  border-radius: 4px;
  height: auto;
  width: 100%;
  padding: 0px;
  margin-top: 4px;

  .icon2{
    font-size: 20px;
  }
 }
.transaction-history-section{
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0.5rem 0 0;
}
.transaction-history-header{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1rem;
  padding: 0 0.25rem;

  h3{
    margin: 0;
    color: #112e25;
    font-family: Poppins;
  }

  span{
    font-size: 13px;
    color: #6b7b75;
    font-family: Poppins;
  }
}
.transaction-history-eyebrow{
  margin: 0 0 0.25rem;
  color: #659610;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 11px;
  font-weight: 700;
  font-family: Poppins;
}
.transaction-history-count{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 92px;
  padding: 0.65rem 0.9rem;
  border-radius: 999px;
  background: #eef5ef;
  color: #24562B;
  font-size: 12px;
  font-weight: 700;
  font-family: Poppins;
}
.transaction-history-list{
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}
.transaction-card{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.1rem;
  border: 1px solid #e6ece8;
  border-radius: 18px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbf9 100%);
  box-shadow: 0 12px 28px rgba(5, 31, 23, 0.06);
}
.transaction-card-main{
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.9rem;
  min-width: 0;
  flex: 1;
}
.transaction-icon{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 16px;
  background: #e8f1eb;
  color: #24562B;
  font-size: 20px;
  flex-shrink: 0;
}
.transaction-copy{
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
}
.transaction-topline{
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.6rem;
}
.transaction-title{
  font-size: 15px;
  font-weight: 700;
  color: #10271f;
  font-family: Poppins;
}
.transaction-badge{
  padding: 0.25rem 0.65rem;
  border-radius: 999px;
  background: #f1f6f2;
  color: #24562B;
  font-size: 11px;
  font-weight: 700;
  text-transform: capitalize;
  font-family: Poppins;
}
.transaction-badge.badge-credit { background: #d4edda; color: #155724; }
.transaction-badge.badge-debit { background: #f8d7da; color: #721c24; }
.transaction-meta{
  color: #51625b;
  font-size: 12px;
  font-family: Poppins;
  word-break: break-word;
}
.transaction-date{
  color: #7b8a84;
  font-size: 11px;
  font-family: Poppins;
}
.transaction-amount-panel{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
  flex-shrink: 0;
}
.transaction-amount-label{
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #7b8a84;
  font-family: Poppins;
}
.transaction-amount{
  font-size: 18px;
  font-weight: 700;
  color: #24562B;
  font-family: Poppins;
}
.transaction-empty-state{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 3rem 1.5rem;
  border: 1px dashed #cdd9d2;
  border-radius: 20px;
  background: #fbfdfb;
  text-align: center;

  i{
    font-size: 34px;
    color: #659610;
  }

  h4{
    margin: 0;
    font-family: Poppins;
    color: #112e25;
  }

  p{
    margin: 0;
    font-size: 13px;
    color: #6b7b75;
    font-family: Poppins;
  }
}
 .activeo{
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;  
  width: 100%;
 }
 .name1{
  color: #24562B;
  font-weight: 450;
  font-size: 14px;
  font-family: Poppins;
}
.get-virtual-card{
  width: 170px;
  height: 48px;
  border-radius: 102px;
  background: var(--Secondary-color, #08294A);
  color: #fff;
  font-family: Poppins;
}
.active-ccc{
  display: flex;
  flex-direction: column;
  padding: 0.4rem;
  width: 35%;
  font-size: 12px !important;
  font-family: Poppins;
}
.view-contract{
  font-size: 10px;
}
.active-cc{
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  font-family: Poppins;
  
  .name{
    color: #24562B;
    font-weight: 500;
    font-family: Poppins;
  }

  .location{
    color: #807b7b;
    font-weight: 550;
    font-size: 11px;
    font-family: Poppins;
    margin-top: 4px;
  }

  .amount{
    color: #24562B;
    font-weight: 500;
    font-family: Poppins;
    font-size: 20px;
    
  }

  .cost-price{
    color: #807b7b;
    font-weight: 600;
    font-family: Poppins;
    margin-top: 10px;
    font-size: 10px;

    button{
      font-size: 10px;
    }
  }
  button{
    font-size: 10px;
  }

  .date{
    font-weight: normal;
    font-family: Poppins;
    font-size: 10px;
  }

 }

 .active-withd{
  width: 80%;
 }
 .active-cc-history{
  display: flex;
  flex-direction: column;
  padding: 0.2rem;
  font-family: Poppins;

  .name{
    font-weight: normal;
    font-family: Poppins;
    font-size: 10px;
    span{
      color: #00000091;
      font-size: 10px;
      font-weight: 500;
    }
  }
  .amount{
    color: #24562B;
    font-weight: normal;
    font-family: Poppins;
    font-size: 16px;
  }
  .date{
    font-weight: normal;
    font-family: Poppins;
    font-size: 9px;
  }

  .amount-w{
    color: #ff2929;
    font-weight: normal;
    font-family: Poppins;
    font-size: 11px;
  }
  .date-w{
    font-weight: normal;
    font-family: Poppins;
    font-size: 9px;
  }

  .name-w{
    font-weight: normal;
    font-family: Poppins;
    font-size: 10px;
    span{
      color: #24562B;
      font-style: italic;
    }
  }

 }

 .active-cc-user{
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-content: center;
  padding: 0.6rem;
  font-family: Poppins;
 }
 .border-style-header{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 0px solid #F4F4F4;
  border-radius: 4px;
  background: #24562B;
  height: 40px;
  color: #fff;
  margin-top: -10px;
}
 .service-box{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 70px;
  width: 100%;
  border-radius: 5px;
  border: solid 0px #fff;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 500;
  color: #fff;
  padding: 0.6rem;
  margin: 4px;
  cursor: pointer;
 }
 .active-c-user{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  height: auto;
  width: 100%;
  padding: 0px;
  margin-top: 4px;
  .icon3{
    font-size: 40px;
  }
 }
 .virtual-card-airtime-money{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height:84px;
  padding: 12px 20px 12px 20px;
  border-radius: 5px;
  background: #24562B;
 }
 .virtual-card-airtime-money1{
  display: none;
 }
 .vcard{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 222.93px;
  height: 53.75px;
  padding: 10px;
  border-radius: 7.69px;
  background: var(--sub-layer, #ECF3FF);
  //font-family: Montserrat;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
 }
 .airtime-v{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 222.93px;
  height: 53.75px;
  padding: 10px;
  border-radius: 7.69px;
  background: var(--sub-layer, #ECF3FF);
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
 }

 .utilities{
  display: flex;
  flex-direction: row;
  justify-content: space;
  align-items: center;
  width: 100%;
  height:84px;
  padding: 12px 20px 12px 20px;
  border-radius: 5px;
  background: #08294A;
}
.airtime-utility{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 226.86px;
  height: 39.86px;
  padding: 11.43px;
  border-radius: 5.71px;
  background: var(--sub-layer, #ECF3FF);
  text-align: center;
  font-size: 13px;
  font-weight: 500;
  color: var(--Primary-Color, #24562B);
}
.utility-icons{
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 80%;

  .icons{
    margin: 3px;
    cursor: pointer;
  }
}

@media screen and (max-width: 768px) {
  .container-fluid{
        padding: 0 0px 0 0rem;
    }

  .pin-modal-mask {
  position: fixed;
  //z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .4s ease;

  &>div {
      width: 90%;
      height: auto;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      backdrop-filter: blur(13px);
      border-radius: 10px;
      box-sizing: border-box;
      font-family: Poppins;
      
  }

}
  .inputs1{
  display: flex;
  flex-direction: column;
  //justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  border-radius: 3px;
  font-size:11px;
  font-weight: 400;
  padding: 0.4rem;
}

  .welcome{
    font-family: Poppins;
    font-size: 16px;
    font-weight: 700;
    padding: 0px 15px;
    text-align: left;
  }

.active-escrow{
  font-size: 12px;
}
.create-escrow{
  display: flex;
  flex-direction: row;
  justify-content:center;
  align-items: center;
  width: 105px;
  height: 30px;
  padding: 0.2rem;
  border-radius: 70.8px;
  background: var(--Primary-Color, #24562B);
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer
}

.search-bar{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0px 20px 0px 15px;
}
.account-summary{
  grid-template-columns: 1fr;
  padding: 0 15px 1rem;
}
.wallet-overview-top{
  flex-direction: column;
}
.wallet-overview-top h3{
  font-size: 24px;
}
.wallet-overview-meta{
  flex-direction: column;
  align-items: flex-start;
}
.account-detail-grid{
  grid-template-columns: 1fr;
}
.inputs-panel{


  .input-field{
    border-right: 1px solid #B7BFC5;
    width: 120px;
  }
}
.bills{
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.9rem;
}
.pay-bills-header{
  align-items: flex-start;
}
.bill-box{
  width: 100%;
  min-height: 150px;
  margin: 0;
  padding: 1rem;
}
.bill-icon{
  width: 48px;
  height: 48px;
  font-size: 18px;
}
.bill-copy{
  margin-top: 1rem;

  h4{
    font-size: 18px;
  }

  p{
    font-size: 12px;
  }
}
.sub-biller-grid{
  grid-template-columns: 1fr;
}
.sub-biller-search-input{
  height: 46px;
  font-size: 12px;
}
.top-menu{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: 0 10px;
  padding: 12px;
  font-size: 10px;
}
.menu{
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  width: 100%;
  font-size: 10px;
}
.top-brand{
  img{
    width: 42px;
    height: 42px;
  }
}
.menu-link{
  padding: 0.6rem 0.85rem;
  font-size: 11px;
}
.marquee{
  margin: 0 15px 10px;
  padding: 0.75rem 0;
  border-radius: 14px;
}
.marquee-track{
  animation-duration: 18s;
}
.marquee-badge{
  font-size: 10px;
  padding: 0.4rem 0.7rem;
}
.marquee-text{
  font-size: 12px;
}
.get-virtual-card{
  font-size: 12px;
  width: 140px;
  height: 40px;
}

  .dashboard-page{
    display: flex;
    flex-direction: column;
    strong{
      margin-top: 10px;
    }
 }
 .dashboard-inner{
  margin: 0px;
  margin-top: 10px;
  padding: 0.5rem;
  //padding: 18px 10px 18px 10px;
 }

 .dashboard-inner-new{
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 255px;
  padding: 10px 15px 10px 15px;
  border-radius: 16px;
  border: 3px solid #F4F4F4;
  background: var(--White-Original, #FFFFFF);
 }
 .active-ccc{
  display: flex;
  flex-direction: column;
  font-size: 10px !important;
  margin-left: 0px;

  .btn-size{
    font-size: 9px !important;
  }
}

.name1{
  font-size: 11px !important;
}
.view-contract{
  font-size: 8px !important;
  width: 80px;
}
 .wallet-board-new{
  display: flex;
  flex-direction: column;
 
  width: 100%;
  height: auto;
  padding: 0.9rem;
  border-radius: 13px;
  
  background: var(--Primary-Color, #24562B);
  color: #fff;

  .avail-amount{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    
    width: 100%;

    .avail-bal{
      //font-family: Montserrat;
      font-size: 11px;
      font-weight: 400;
    }
    .trans-his{
      //font-family: Montserrat;
      font-size: 10px;
      font-weight: normal;
      color: #D9D9D9;
    }

  }
  .tran-history{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .balance{
      font-family: Montserrat;
      font-size: 20px;
      font-weight: 600;
    }
   .pending-history{
    display: flex;
    flex-direction: column;
   }
    .pending{
      //font-family: Montserrat;
      font-size: 10px;
      font-weight: normal;
      color: #D9D9D9;
    }
    .pending-fund{
      //font-family: Montserrat;
      font-size: 12px;
      font-weight: 600;
    }
  }
 }
 .add-withd-panel{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
 }
 .add-fund{
  width: Fixed (111.7px)px;
  height: Fixed (38px)px;
  padding: 12.67px 16.12px 12.67px 16.12px;
  border-radius: 81.53px;
  
  background: var(--Primary-Color, #24562B);
  //font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: 12.79px;
  text-align: left;
  color: #FFFFFF;
  margin-right: 4px;

 }
 .withd-fund{
  width: Fixed (112.59px)px;
  height: Hug (38px)px;
  padding: 12.67px 9.85px 12.67px 9.85px;
  border-radius: 81.53px;
  
  background: var(--Secondary-color, #08294A);
  //font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: 12.79px;
  text-align: left;
  color: #FFFFFF;

 }

 .active-c{

  .icon{
    font-size: 40px;
  }
 }
 .activeo{
  //margin-left: -6px;
 }
 .active-cc{
  display: flex;
  flex-direction: column;
  padding: 0.3rem;
  font-family: Poppins;
  width: 100%;

  .name1{
    color: #24562B;
    font-weight: 500;
    font-family: Poppins;
    font-size: 10px;
  }

  .name{
    color: #24562B;
    font-weight: 500;
    font-family: Poppins;
    font-size: 10px;
  }

  .location{
    color: #807b7b;
    font-weight: 200;
    font-family: Poppins;
    margin-top: 10px;
    font-size: 10px;
  }

  .amount{
    color: #24562B;
    font-weight: 500;
    font-family: Poppins;
    font-size: 10px;
  }

  .cost-price{
    color: #807b7b;
    font-weight: 600;
    font-family: Poppins;
    margin-top: 10px;
    font-size: 10px;
  }

  .date{
    font-weight: normal;
    font-family: Poppins;
    font-size: 10px;
  }

 }
 .wallet-board{
  padding: 0.5rem;
}

.account-note{
  border-bottom: solid 1px #ccc;
  padding: 0.4rem;

    p{
      font-family: Poppins;
      font-weight: normal;
      font-size: 11px;
      line-height: 1;
    }

 }
 .account-number{
    padding: 0.4rem;
  
  div{
    font-family: Poppins;
    font-weight: normal;
    font-size: 10px;
    color: #ccc;
    span{
      color: #fff;
      font-size: 11px;
    }
  }
 }
 .wallet-balance{
    h4{
      font-weight: normal;
      font-size: 14px;
      color: #000;
      text-shadow: 1px 0px 1px #ccc;
    }
 }
 .withdrawal{
    font-family: Poppins;
    font-weight: normal;
    font-size: 10px;
    color: #24562B;
    border: solid 1px;
    padding: 0.2rem;
 }

 .active-c-history{
  padding: 0px;
  margin-top: 10px;
  .icon2{
    font-size: 15px;
  }
 }
 .transaction-history-header{
  align-items: flex-start;
 }
 .transaction-history-count{
  min-width: auto;
 }
 .transaction-card{
  flex-direction: column;
  align-items: flex-start;
  padding: 0.95rem;
 }
 .transaction-card-main{
  width: 100%;
  align-items: flex-start;
 }
 .transaction-icon{
  width: 44px;
  height: 44px;
  font-size: 18px;
 }
 .transaction-topline{
  flex-direction: column;
  align-items: flex-start;
  gap: 0.4rem;
 }
 .transaction-title{
  font-size: 10px;
 }
 .transaction-meta{
  font-size: 10px;
 }
 .transaction-date{
  font-size: 10px;
 }
 .transaction-amount-panel{
  width: 100%;
  align-items: flex-start;
  padding-left: 3.2rem;
 }
 .transaction-amount{
  font-size: 16px;
 }
 .transaction-empty-state{
  padding: 2rem 1rem;
 }

 .active-cc-history{
  padding: 0.2rem;
  font-family: Poppins;

  .name{
    font-weight: normal;
    font-family: Poppins;
    font-size: 9px;
    
    span{
      color: #00000091;
      font-style: italic;
    }
  }
  .amount{
    color: #24562B;
    font-weight: normal;
    font-family: Poppins;
    font-size: 9px;
  }
  .date{
    font-weight: normal;
    font-family: Poppins;
    font-size: 8px;
  }

  .amount-w{
    color: #ff2929;
    font-weight: normal;
    font-family: Poppins;
    font-size: 9px;
  }
  .date-w{
    font-weight: normal;
    font-family: Poppins;
    font-size: 8px;
  }

  .name-w{
    font-weight: normal;
    font-family: Poppins;
    font-size: 9px;
    span{
      color: #24562B;
      font-style: italic;
    }
  }

 }
 .dashboard-inner1{
  display: flex;
  flex-direction: column;
  padding: 18px 10px 18px 10px;
 }
 .active-cc-user{
  display: flex;
  flex-direction: row;
  justify-content: center !important;
  align-content: center;
  //padding: 0rem;
  font-family: Poppins;
  width: 100%;
 }
 .border-style-header{
  width: 100%;
}
 .service-box {
  width: 100%;
 }
 .active-c-user{
  padding: 0px;
  margin-top: 4px;
  .icon3{
    font-size: 23px;
  }
 }
 .account-content {
  margin: 0px;
  margin-right: 0px;
}
.virtual-card-airtime-money{
  display: none;
 }
.virtual-card-airtime-money1{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height:84px;
  padding: 0px 10px 0px 10px;
  border-radius: 5px;
  background: #24562B;
 }
 .vcard{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  padding: 0px;
  border-radius: 7.69px;
  background: var(--sub-layer, #ECF3FF);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
 }
 .airtime-v{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  padding: 0px;
  border-radius: 7.69px;
  background: var(--sub-layer, #ECF3FF);
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;

 }
 .util-m{
  margin: 2px;
 }
 .utilities{
  padding: 12px 20px 12px 10px;
}
 .airtime-utility{
  display: none;
 }

 .utility-icons{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100% !important;
  padding-left: 0px;
  
  .icons{
    cursor: pointer;
  }
}
  
}

</style>
